if (!customElements.get('promo-material-banner')) {
  customElements.define(
    'promo-material-banner',
    class PromoMaterialBanner extends HTMLElement {
      constructor() {
        super();

        this.onClose = this.onClose.bind(this);
        this.onVariantChange = this.onVariantChange.bind(this);
        this.onCartUpdate = this.onCartUpdate.bind(this);
      }

      connectedCallback() {
        this.context = this.dataset.context;
        this.threshold = Number(this.dataset.threshold) || 10000;
        this.closeButton = this.querySelector('[data-promo-material-close]');
        this.closeButton?.addEventListener('click', this.onClose);

        if (this.context === 'product') {
          this.productForm = this.closest('form[is="product-form"]');
          this.productForm?.addEventListener('variant:change', this.onVariantChange);
          this.updateProduct(Number(this.dataset.currentWeight));
          return;
        }

        this.scope = this.closest('[id^="MiniCart-"]') || this.closest('main-cart');
        this.updateCart(Number(this.dataset.currentWeight));

        if (window.theme?.pubsub) {
          this.cartUpdateUnsubscriber = theme.pubsub.subscribe(
            theme.pubsub.PUB_SUB_EVENTS.cartUpdate,
            this.onCartUpdate
          );
        }
      }

      disconnectedCallback() {
        this.closeButton?.removeEventListener('click', this.onClose);
        this.productForm?.removeEventListener('variant:change', this.onVariantChange);
        this.cartUpdateUnsubscriber?.();
      }

      onVariantChange(event) {
        this.updateProduct(Number(event.detail.variant?.weight));
      }

      onCartUpdate(event) {
        if (!event.cart?.errors) {
          this.updateCart(Number(event.cart?.total_weight));
        }
      }

      onClose() {
        this.hidden = true;

        try {
          sessionStorage.setItem('promoMaterialBannerDismissed', 'true');
        }
        catch (error) {
          // Storage can be unavailable in privacy-restricted browsers.
        }
      }

      updateProduct(weight) {
        this.hidden = !Number.isFinite(weight) || weight < this.threshold;
      }

      updateCart(weight) {
        const isActive = Number.isFinite(weight) && weight >= this.threshold;
        this.hidden = !isActive || this.isDismissed();

        if (!this.scope) return;

        this.scope.querySelectorAll('.promo-material-checkout-button').forEach((button) => {
          button.classList.toggle('is-promo-material-active', isActive);
        });

        this.scope.querySelectorAll('.promo-material-checkout-message').forEach((message) => {
          message.hidden = !isActive;
        });
      }

      isDismissed() {
        try {
          return sessionStorage.getItem('promoMaterialBannerDismissed') === 'true';
        }
        catch (error) {
          return false;
        }
      }
    }
  );
}
